import { type ReactNode } from "react";

type Props = {
  children: ReactNode;
  speed?: number; // seconds per loop
  className?: string;
};

/** Modern, hardware-accelerated take on the <marquee> tag. */
export function Marquee({ children, speed = 30, className = "" }: Props) {
  const items = (
    <div className="flex shrink-0 items-center gap-8 px-4">{children}</div>
  );
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className="flex w-max animate-marquee will-change-transform"
        style={{ animationDuration: `${speed}s` }}
      >
        {items}
        {items}
      </div>
    </div>
  );
}
